import axios from 'axios';
import { encryptQueryParams } from './encrypt-qs';

const instance = axios.create({
  baseURL        : process.env.REACT_APP_BOB_API,
  timeout        : process.env.REACT_APP_REQUESTS_TIMEOUT || 3000,
  withCredentials: true,
  headers        : { 'Bob-Origin-Platform': 'backoffice' },
});

export const errors = {
  noResponse: 'No response from server',
  noResults : 'No results found',
};

instance.interceptors.response.use((response) => {
  const { code, data } = response.data;
  if (code >= 300) {
    // TODO: improve how we manage the api errors instead of throw generic error
    throw new Error(errors.noResults);
  }
  return data;
});
export const fetchDelete = (url, body) => instance.delete(url, { data: body });

export const fetchGet = (url, config) => instance.get(url, config);

export const fetchEncryptGet = (url, params) => instance.get(`${url}?${encryptQueryParams(params)}`);

export const fetchPost = (url, body) => instance.post(url, body);

export const fetchPut = (url, body) => instance.put(url, body);

export const fetchPatch = (url, body) => instance.patch(url, body);

export default {
  fetchPost,
};
